var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"w-full",class:[_vm.sizeClass],attrs:{"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"outline",attrs:{"cx":"50","cy":"50","r":"40"}}),_c('circle',{staticClass:"animation",attrs:{"cx":"50","cy":"50","r":"40"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }